export function fetchSearch(domainName) {
    return fetch("https://qwords.com/apis/find-irsfa.php?domain=" + domainName)
      .then(response => response.json())
      .catch((error) => {
        console.log(error);
      })
}

export function fetchExtensionRegister(extension) {
  return fetch(`${process.env.REACT_APP_BASE_API}order/apis/get-price-domain.php?tipedomain=domainregister&extension=${extension}`)
    .then(response => response.json())
    .catch((error) => {
      console.log(error);
    });
}

export function fetchExtensionTransfer(extension) {
  return fetch(`${process.env.REACT_APP_BASE_API}order/apis/get-price-domain.php?tipedomain=domaintransfer&extension=${extension}`)
    .then(response => response.json())
    .catch((error) => {
      console.log(error);
    });
}

export function fetchPriceRenew(extension) {
  return fetch(`${process.env.REACT_APP_BASE_API}order/apis/get-price-domain.php?tipedomain=domainrenew&extension=${extension}`)
    .then(response => response.json())
    .catch((error) => {
      console.log(error);
    });
}

export function fetchGetStatus(domainName) {
  return fetch(`${process.env.REACT_APP_BASE_API}apis/getStatusDomain.php?domain=${domainName}`)
    .then(response => response.json())
    .catch((error) => {
      console.log(error);
    });
}

export function fetchRegistrar(extension) {
  return fetch(`${process.env.REACT_APP_BASE_API}/apis/checkregistrar.php?extension=${extension}`)
    .then(response => response.json())
    .catch((error) => {
      console.log(error);
    });
}

export function fetchDomainPromo(payload){
  return fetch(`${process.env.REACT_APP_BASE_API}order-api/api/v1/promotion/check`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-Requested-With" : "XMLHttpRequest"
    },
    body: JSON.stringify(payload),
  })
  .then(response => response.json())
}
